var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6875 15H10.9531C11.3302 15 11.6919 14.8525 11.9585 14.5899C12.2252 14.3274 12.375 13.9713 12.375 13.6V4.5L8.82031 1H2.42188C2.04477 1 1.68311 1.1475 1.41646 1.41005C1.1498 1.6726 1 2.0287 1 2.4V9.4",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10938 1V3.8C8.10938 4.1713 8.25918 4.5274 8.52583 4.78995C8.79249 5.0525 9.15415 5.2 9.53125 5.2H12.375M5.55 8.42C5.83283 8.14152 6.21643 7.98508 6.61641 7.98508C7.01639 7.98508 7.39998 8.14152 7.68281 8.42C7.96564 8.69848 8.12453 9.07617 8.12453 9.47C8.12453 9.86383 7.96564 10.2415 7.68281 10.52L3.84375 14.3L1 15L1.71094 12.2L5.55 8.42Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.2d64b7e08b52b70dd0e40d76cc081f12.svg";
export { ForwardRef as ReactComponent };